import TemplateView from '../../../TemplateView'
import {Pager as PagerConstants, UserManagementConstants} from 'constants'
import PagerController from "../../../pager/PagerController";

export default class Pager extends TemplateView {
    constructor({
        onChangeUserPerPage = () => {},
        onChangePageNum = () => {},
    }) {
        super(null)

        this.params = {
            onChangeUserPerPage,
            onChangePageNum,
        }

        this.state = {
            totalNumberOfUsers: 0,
            pageNum: 1,
            usersPerPage: 1,
        }

        this.onStateChanged(() => {
            this.pagerController.setPagerStateAndUpdateUI(this.state.totalNumberOfUsers, this.state.pageNum, this.state.usersPerPage)
        })
    }

    templateHtml() {
        return '<table class="userListFooter">' +
               '    <tr>' +
               '        <td class="usersPerPage">' +
               '            <table>' +
               '                <tr>' +
               '                  <td class="showCaption"><%=show%></td>' +
               '                  <td class="selector" >' +
               '                    <select name="recordsPerPage" class="recordsPerPageSelector">' +
               '                        <% _.each(pagesSet, function(value) { %>' +
               '                            <option value="<%=value%>"><%=value%></option>' +
               '                        <% }); %>' +
               '                    </select>' +
               '                  </td>' +
               '                  <td class="userPerPageCaption"><%=perPage%></td>' +
               '               </tr>' +
               '            </table>' +
               '        </td>' +
               '        <td class="tableNavigation" colspan="5">' +
               '            <div class="pager"></div>' +
               '        </td>' +
               '    </tr>' +
               '</table>'
    }

    messageKeys() {
        return {
            show: 'userlist.table.show',
            perPage: 'userlist.table.users_per_page'
        }
    }

    templateModel() {
        return {
            pagesSet: PagerConstants.CUSTOM_PAGE_SET_2
        }
    }

    afterRender() {
        this.pagerController = new PagerController().init(
            {
                handlersMap: {
                    pageChanged: this.params.onChangePageNum,
                    recordsPerPageChanged: this.params.onChangeUserPerPage,
                },
                pagerControlsElement: this.$el[0],
                pagerElement: this.find('.pager')[0],
                recordsPerPageSelectorElement: this.find('.recordsPerPageSelector')[0],
                minRecordsPerPage: UserManagementConstants.MIN_RECORDS_PER_PAGE,
                ignoreHashChange: true,
            }
        )
        this.pagerController.render()
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/Pager.js